<template>
  <Modal
    v-model="modal"
    :title="$t('PB_Select_Employee_Search')"
    width="70%"
    :closable="false"
   
    ><!-- 选择员工 -->
    <Form :model="modalFormItem" :label-width="90"  class="modalClass">
      <Row :gutter="20">
        <Col :xs="24" :sm="24" :md="12" :lg="5">
          <FormItem :label="$t('BU')"
            ><!-- 业务单元 -->
            <Select
              v-model="modalFormItem.businessUnit"
              clearable
              style="width:100%"
            >
              <Option
                v-for="item in businessUnitList"
                :value="item.ch_value"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="5">
          <FormItem :label="$t('Department')"
            ><!-- 部门 -->
            <Select
              v-model="modalFormItem.department"
              clearable
              style="width:100%"
            >
              <Option
                v-for="item in departmentList"
                :value="item.ch_value"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="5">
          <FormItem :label="$t('Management_Level')"
            ><!-- 管理层级 -->
            <!-- <Input v-model="modalFormItem.hrManage" /> -->
            <Select
              v-model="modalFormItem.hrManage"
              clearable
              style="width:100%"
            >
              <Option
                v-for="item in ManagementLevel"
                :value="item.ch_value"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="5">
          <FormItem :label="$t('Position')"
            ><!-- 职位 -->
            <Input v-model="modalFormItem.position" />
            <!-- <Select v-model="modalFormItem.position" clearable style="width:100%">
              <Option v-for="item in positionList" :value="item.ch_value" :key="item.code">{{item.ch_value}}</Option>
            </Select> -->
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="5">
          <FormItem :label="$t('Employee_Code')"
            ><!-- 员工号 -->
            <Input type="text" v-model="modalFormItem.empCode" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="5">
          <FormItem :label="$t('Name')"
            ><!-- 姓名 -->
            <Input type="text" v-model="modalFormItem.userName" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="5">
          <FormItem :label="$t('English_Name')"
            ><!-- 英文名 -->
            <Input type="text" v-model="modalFormItem.userEName" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="5">
          <FormItem :label="$t('Band')">
            <Select
              v-model="modalFormItem.hcmBand"
              clearable
              style="width:100%"
            >
              <Option
                v-for="item in Band"
                :value="item.ch_value"
                :key="item.code"
                >{{ item.ch_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="2">
          <FormItem style="display: flex;justify-content: end;">
            <Button @click="getData"><!-- 检 索 -->{{ $t("Search") }}</Button>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <Table
      highlight-row
      height = "550"
      border
      :columns="modelColumns"
      :loading="loading"
      :data="modelData"
      @on-selection-change="itemClick"
      ref="selection"
    >
      <template slot="action1" slot-scope="{ row, index }">
        <Icon
          size="26"
          color="#006B37"
          type="md-menu"
          @click="onSelect(row, index)"
        />
      </template>
    </Table>
    <!-- <div style="display: flex;justify-content: end;margin-top: 30px;">
      <Page :total="total" @on-change="pageChange"></Page> 
    </div> -->

    <div slot="footer">
      <Button type="text" @click="handleConfirm">{{ $t("Confirm") }}</Button>
      <Button type="text" @click="handleCancle">{{ $t("Cancel") }}</Button>
    </div>
  </Modal>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      modal: false,
      loading: false,
      modalFormItem: {},
      modelData: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 9999
      },
      total: 0,
      list: [],
      positionList: [],
      ApplyStatus: [],
      departmentList: [],
      businessUnitList: [],
      ManagementLevel: [],
      Level: [],
      Band: [],
      selectList: [],
      id: "",
      targetType: ""
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    modelColumns() {
      return [
        {
          type: "selection",
          minWidth: 60,
          align: "center"
        },
        {
          title: this.$t("Employee_Code") /* 工号 */,
          key: "empCode",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "eName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Position") /* 职位 */,
          key: "position",
          align: "center",
          minWidth: 200
        }
      ];
    }
  },
  created() {
    // this.getData()
    this.getListData();
  },
  watch: {
    selectList: {
      handler(newVal, oldVal) {
        newVal.forEach(res => {
          this.modelData.forEach((el, index) => {
            el._checked = false;
            if (el.empCode === res.empCode) {
              this.$refs.selection.objData[index]._isChecked = true;
            }
          });
        });
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.departmentList = res.departmentList;
          this.businessUnitList = res.businessUnitList;
          this.Level = res.Level;
          this.Band = res.Band;
          this.ManagementLevel = res.ManagementLevel;
        }
      });
    },
    getData() {
      let obj = {
        id: this.id,
        ...this.modalFormItem,
        ...this.pageInfo,
        targetType: this.targetType
      };
      this.loading = true;
      this.selectList = [];
      axios.post("/achTargetSetting/selectShareInfo", obj).then(res => {
        this.loading = false;
        if (res) {
          this.modelData = res.data;
          // this.modelData.forEach(el => {
          //   el._checked=false
          // })

          this.total = parseInt(res.pageInfo.total);
          this.$nextTick(() => {
            this.modelData.forEach((el, index) => {
              el._checked = false;
              if (el.isFlag == "1") {
                this.selectList.push(el);
                this.$refs.selection.objData[index]._isChecked = true;
              }
            });
          });
        }
      });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    handleConfirm() {
      // if(this.selectList.length<=0){
      //     this.$Message.error('请选择分享人');
      //     return
      // }
      // this.modal=false
      this.$emit("onSelectList", JSON.parse(JSON.stringify(this.selectList)));
      // this.$nextTick(() => {
      //   this.$refs.selection.selectAll(false);
      // })
    },
    handleCancle() {
      this.modal = false;
      this.$nextTick(() => {
        this.$refs.selection.selectAll(false);
      });
    },
    itemClick(list) {
      this.selectList = JSON.parse(JSON.stringify(list));
    }
  }
};
</script>
<style scoped>
  .modalClass{
    overflow: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/AchTargetSettingComponents/ShareUser.vue